import { supabase } from '../lib/supabaseClient.ts';
export const getSession = async ()=> {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) throw new Error(`Session error: ${error.message}`);
  if (!session) throw new Error('No active session');
  return session;
};
